<template>
  <div class="edit-one-of-profile-wrapper">
    <h1 class="a11y-hidden">웨이브</h1>
    <div class="header-top">
      <h2 class="hd-title">프로필 수정</h2>
      <button class="btn-back" type="button" @click.prevent="close">
        <span class="a11y-hidden">뒤로 가기</span>
        <span class="icon-back"><GnbBackIcon></GnbBackIcon></span>
      </button>
    </div>
    <div class="lnb-member-wrap">
      <div class="lnb-side-top">
        <div class="profile-select">
          <img :src="'https://' + currentProfile.image" alt="프로필 이미지" class="profile-sample-img" v-if="currentProfile.image">
        </div>
        <div class="profile-img-list">
          <ul>
            <!-- index 가 0 부터 시작안하고 1부터 시작해서.. -->
            <li v-for="(image, index) in profileImage.list" :key="'profileImage' + index"
                class="sample-img-list"
                @click="()=>changeProfileImage(image.imageid, currentProfile.multiprofile !== 'y')">
              <button :class="currentProfile.image === image.image ? 'ch-profile' : ''">
                <img :src="'https://' + image.image" alt="프로필 이미지" class="profile-sample-img">
                <span class="checked"><CheckMIcon v-if="currentProfile.image === image.image"></CheckMIcon></span>
                <span class="profile-change-common"></span>
              </button>
            </li>
          </ul>
        </div>
        <div class="profile-name-modify" v-if="currentProfile.multiprofile === 'y'">
          <label for="profile-name-modify"><span class="a11y-hidden">프로필1</span></label>
          <input type="text" title="프로필 이름 변경 입력 영역" id="profile-name-modify"
                 :value="currentProfile.profilename" v-on:input="modifyName = $event.target.value">
        </div>
      </div>

      <div class="lnb-modify-btn-box" v-if="currentProfile.multiprofile === 'y'">
        <a href="#" class="btn-cancle" @click.prevent="close">취소</a>
        <a href="#" class="btn-confirm" @click.prevent="submitChangeProfile">확인</a>
      </div>
    </div>

  </div>
</template>

<script>
import utils from '@/common/util/utils'
import { UserService } from '@/common/api/api.service'
import GnbBackIcon from '@/assets/svg/common/ic_gnb_back_w.svg'
import CheckMIcon from '@/assets/svg/common/ic-check-m.svg'
import { reverse, get } from 'lodash'
export default {
  name: 'LnbEditUserOneOfProfile',
  components: {
    GnbBackIcon,
    CheckMIcon
  },
  data () {
    return {
      currentProfile: {},
      profileImage: {},
      modifyName: null,
      currentImageId: null,
      nameByte: 0,
      profileId: ''
    }
  },
  methods: {
    close () {
      this.$router.back()
    },
    changeProfileImage (imageId, oneUser) {
      const selectImage = this.currentProfile.image = this.profileImage.list.filter((item) => {
        return item.imageid === imageId
      })[0]
      if (this.currentImageId !== selectImage.imageid) {
        this.currentProfile.image = selectImage.image
        this.currentImageId = +selectImage.imageid
        if (oneUser) {
          this.submitChangeProfile()
        }
      } else {
        this.currentProfile.image = this.currentProfile.image.image
      }
    },
    submitChangeProfile () {
      if (this.nameByte > 50) {
        utils.alert('프로필명은 최대 50Byte 까지 설정 가능합니다.')
      }
      const cs = JSON.parse(utils.cookies.getItem('cs'))
      if (cs.profile === String(this.profileId)) {
        utils.cookies.changeUserInfo(this.modifyName || this.currentProfile.profilename, this.profileImage.list[this.currentImageId - 1].image)
      }
      UserService.updateUserOneOfProfile({
        profileId: this.profileId,
        imageId: this.currentImageId,
        profileName: this.modifyName || this.currentProfile.profilename
      }).then(() => {
        this.close()
      })
    }
  },
  watch: {
    modifyName (newVal, oldVal) {
      let len = 0
      for (let i = 0; i < this.modifyName.length; i++) {
        if (escape(this.modifyName.charAt(i)).length === 6) {
          len++
        }
        len++
        this.nameByte = len
        if (this.nameByte > 50) {
          utils.alert('프로필명은 최대 50Byte 까지 설정 가능합니다.')
          this.modifyName = this.modifyName.substring(0, i)
          return
        }
      }
    }
  },
  created () {
    this.profileId = get(this.$route, ['params', 'profileNumber'], 0)
    const imageListReq = UserService.getUserProfileImageList({ offset: 0, limit: 10, orderBy: 'new' })
    const userProfileReq = UserService.getUserOneOfProfile({ profileId: this.profileId })
    this.axios.all([imageListReq, userProfileReq]).then(this.axios.spread((imageListRes, userProfileRes) => {
      let imageList = imageListRes.data
      let userProfile = userProfileRes.data
      const currentUserImage = userProfile.image
      const currentImageId = imageList.list.filter((item) => {
        return item.image === currentUserImage
      })[0].imageid
      this.currentImageId = currentImageId
      this.currentProfile = userProfile
      this.profileImage = imageList
      this.profileImage.list = reverse(this.profileImage.list)
      this.modifyName = this.currentProfile.profilename
    }))
  }
}
</script>

<style scoped>
  .edit-one-of-profile-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4300;
    background-color: #1b1b1b;
  }
  .sample-img-list img,
  .profile-select img {
    width: 100%;
  }
  span.checked {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    margin-top: -10px;
    margin-left: -10px;
  }
  .ch-profile:after{
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(19, 81, 249, 0.8) no-repeat center;
    background-size: 24px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 100px;
  }
</style>
